import type { FunctionComponent } from 'react'

const CustomHTMLBlock: FunctionComponent<{ body: TrustedHTML }> = ({ body }) => (
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={{ __html: body }} />
)

export default CustomHTMLBlock
